const adaptEditBrand = (data: Partial<AppBrand>): Partial<IAppBrand> => {
	return {
		id: data.id,
		name: data.name,
		brand_color: data.brandColor,
		text_color: data.textColor,
	};
};

export default adaptEditBrand;
